import React from "react";
import styled from "styled-components";
import bannerImage from "./assets/banner.png";
import AccellorLogo from "./assets/logo_accellor_white.svg";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./Auth/authConfig";

const LoginContainer = styled.div`
  background: url(${bannerImage});
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
`;

const LoginBanner = styled.div`
  margin: 0 auto;
  padding: 0 30px;
  max-width: 1120px;
`;
const Header = styled.div`
  padding: 40px 0 0;
  margin-bottom: 160px;
  img {
    width: 150px;
  }
`;
const LoginContent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;
const LoginHeading = styled.div`
  width: 55%;
  max-width: 550px;
  h2 {
    font-size: 80px;
    line-height: 80px;
    font-weight: 900;
    color: #fff;
  }
  p {
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
    color: #fff;
    margin-top: 50px;
  }
`;
const LoginBox = styled.div`
  background: rgb(255 255 255);
  padding: 40px;
  width: 40%;
  border-radius: 16px;
  h2 {
    font-size: 20px;
    line-height: 30px;
    font-weight: 800;
    color: #29313d;
  }
  p {
    font-size: 18px;
    line-height: 22px;
    color: #29313d;
    margin-top: 20px;
  }
  button {
    margin-top: 30px;
    min-height: 41px;
    background-color: #2f2f2f;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: none;
    outline: none;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    cursor: pointer;
  }
`;
const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };
  return (
    <LoginContainer>
      <LoginBanner>
        <Header>
          <img src={AccellorLogo} alt="Accellor Logo" />
        </Header>
        <LoginContent>
          <LoginHeading>
            <h2>Advanced Document Intelligence Platform</h2>
            <p>Reimagine your data with GenAI</p>
          </LoginHeading>
          <LoginBox>
            <h2>Sign in</h2>
            <p>Use your Accellor account credentials to chat.</p>
            <button onClick={handleLogin}>Get started</button>
          </LoginBox>
        </LoginContent>
      </LoginBanner>
    </LoginContainer>
  );
};

export default Login;
